import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SettingsService {
    getSettings(): Observable<any> {
        return of({
            user: {
                fullName: 'Admin User',
                email: 'admin@sit.ac.in'
            },
            settings: {
                autoEnrollment: true,
                emailVerification: true,
                aiCourseGeneration: true,
                emailNotifications: true,
                weeklyReports: true
            }
        });
    }
}
